// src/components/modules/ui/InfoModal.jsx
import React from 'react'
import { Dialog, DialogTitle, DialogContent, DialogActions, Slide } from '@mui/material'
import { Text } from '../../../components/modules/ui'
import CustomButton from '../../../components/modules/ui/CustomButton'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='down' ref={ref} {...props} />
})

const InfoModal = ({ open, onClose }) => {
  // aquí la glosa interna
  const DOC_LEYENDA = [
    { label: 'Factura Electrónica', abbr: 'FEL', code: '33' },
    { label: 'Factura no Afecta o Exenta Electrónica', abbr: 'FNA', code: '34' },
    { label: 'Total Oper. Del mes Boleta electr.', abbr: 'BEL', code: '39' },
    { label: 'Liquidación-Factura Electrónica', abbr: 'LFE', code: '43' },
    { label: 'Factura de Compra', abbr: 'FCO', code: '45' },
    { label: 'Total mes Comprobantes Pago Electrónico', abbr: 'CPE', code: '48' },
    { label: 'Nota de Crédito Electrónica', abbr: 'NCE', code: '61' },
    { label: 'Factura de Exportación Electrónica', abbr: 'FEX', code: '110' },
    { label: 'Declaración de Ingresos', abbr: 'DIN', code: '914' },
    { label: 'Boleta', abbr: 'BHE', code: '100' }
  ]

  return (
    <Dialog
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      keepMounted
      maxWidth='sm'
      fullWidth
    >
      <DialogTitle>Leyenda de Abreviaciones Documento</DialogTitle>
      <DialogContent dividers>
        <div className='space-y-2 text-sm'>
          {DOC_LEYENDA.map(item => (
            <Text key={item.code}>
              {item.label} ({item.abbr}) {item.code}
            </Text>
          ))}
        </div>
      </DialogContent>
      <DialogActions>
        <CustomButton
          className='rounded-full min-h-9'
          color='primary'
          title='CERRAR'
          onClick={onClose}
        ></CustomButton>
      </DialogActions>
    </Dialog>
  )
}

export default InfoModal
